import useElementSize from '.';
/**
 * If Width & Height are needed, call directly useElementSize
 */
const useElementHeight = target => {
    const { height } = useElementSize(target);
    return height;
};
export default useElementHeight;
